import { Auth } from "aws-amplify";

export default function fetchCurrentUser() {
  return Auth.currentAuthenticatedUser();
}
